import {
    SYLNDR_USER_SERVICE_BASE_URL,
    COMMON_SERVER_HEADERS,
    authTokenKey,
} from '@/constants';
import {
    IAuthUpdateInfoResponse,
    IAuthGetUpdatedToken_RESULT,
    IUpdateUserInfoBody,
    IUpdateUserInfoRequestParameters,
    IUserSignInReponse,
} from '@/types';
import { SylndrStorage } from '@/classes/SylndrStorage';
import To from '@/libs/to-promise';
import pino from 'pino';

const logger = pino().child({ s: 'src/api-requests/auth' });
const authStorage = new SylndrStorage();

export const updateUserInfo = async ({
    id,
    name,
    email,
    emptyEmail,
}: IUpdateUserInfoRequestParameters): Promise<IAuthUpdateInfoResponse> => {
    const url = `${SYLNDR_USER_SERVICE_BASE_URL}/v1.0/user/${id}`;
    const updateBody: Partial<IUpdateUserInfoBody> = {};
    if (name) updateBody.name = name;
    if (email && email.length) {
        updateBody.email = email;
    }
    if (emptyEmail) {
        updateBody.email = '';
    }
    const userToken = authStorage.getItem(authTokenKey);
    const [err, res] = await To(
        fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userToken}`,
                ...COMMON_SERVER_HEADERS,
            },
            body: JSON.stringify(updateBody),
        })
    );
    if (err) {
        logger.error(err);
        return {} as IAuthUpdateInfoResponse;
    }
    const [dataParseError, data] = await To(res.json());
    if (dataParseError) {
        logger.info('Error while trying to parse updateUserInfo response.');
        logger.info('original data provided is ', data);
        logger.error(dataParseError);
        return {} as IAuthUpdateInfoResponse;
    }
    return data;
};
export const getUpdatedToken =
    async (): Promise<IAuthGetUpdatedToken_RESULT> => {
        const url = `${SYLNDR_USER_SERVICE_BASE_URL}/v1.0/user-auth/refresh-token`;
        const userToken = authStorage.getItem(authTokenKey);
        const [err, res] = await To(
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${userToken}`,
                    ...COMMON_SERVER_HEADERS,
                },
            })
        );
        if (err) {
            logger.error(err);
            return {} as IAuthGetUpdatedToken_RESULT;
        }
        const [dataParseError, data] = await To(res.json());
        if (dataParseError) {
            logger.info('Error while trying to parse updateUserInfo response.');
            logger.info('original data provided is ', data);
            logger.error(dataParseError);
            return {} as IAuthGetUpdatedToken_RESULT;
        }
        return data;
    };
export const userAuthSignIn = async ({
    phone,
    otp,
}: {
    phone: string;
    otp: string;
}): Promise<IUserSignInReponse> => {
    const url = `${SYLNDR_USER_SERVICE_BASE_URL}/v1.0/user-auth/sign-in`;
    const [err, res] = await To(
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...COMMON_SERVER_HEADERS,
            },
            body: JSON.stringify({
                phone,
                otp,
            }),
        })
    );
    if (err) {
        logger.error(err);
        return {} as IUserSignInReponse;
    }
    const [dataParseError, data] = await To(res.json());
    if (dataParseError) {
        logger.info('Error while trying to parse userAuthSignIn response.');
        logger.info('original data provided is ', data);
        logger.error(dataParseError);
        return {} as IUserSignInReponse;
    }
    return data;
};
